const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

function resolveBaseUrl() {
    if (typeof window !== 'undefined' && LOCAL_HOSTS.has(window.location.hostname)) {
        return `${window.location.origin}/api/v1`;
    }
    return import.meta.env.VITE_BASE_URL || 'http://127.0.0.1:8000/api/v1';
}

export const baseUrl = resolveBaseUrl();
// export const baseUrl = import.meta.env.VITE_BASE_URL || 'http://127.0.0.1:8000/api/v1';
// `privateKey` is a misnomer kept for compatibility — it holds the PUBLISHABLE
// key (pk_...), which is meant to be public and is what loadStripe() needs.
//
// `secretKey: import.meta.env.VITE_STRIPE_SECRET` was removed. Vite inlines
// every VITE_* variable into the browser bundle at build time, so that line put
// a Stripe SECRET key one reference away from shipping to every visitor. It
// survived only because nothing read it and Rollup dropped the unused property.
// A browser has no legitimate use for a secret key — all secret-key work happens
// server-side in PaymentController. Delete VITE_STRIPE_SECRET from .env too.
export const StripePayment = {
    privateKey: import.meta.env.VITE_STRIPE_KEY,
}
/**
 * Base URL of the event manager app.
 *
 * A separate app served off its own path, so links to it are real navigations,
 * not SPA routes. Callers append a path:
 *
 *     `${managerBaseUrl}/event-setup`  ->  https://apsession.com/manager/event-setup
 *
 * The fallback is not decoration. Vite inlines VITE_* at BUILD time, so an
 * unset variable becomes the string "undefined" in the shipped bundle and every
 * manager link turns into a relative `undefined/event-setup` — which the browser
 * resolves against the current origin. VITE_MANAGER_BASE_URL is deliberately
 * left out of the required-vars check in .gitlab-ci.yml on the strength of this
 * fallback, so removing it breaks every production build.
 *
 * Keep this value in step with header.jsx and the backend CTA URLs in
 * config/event_upgrades.php and config/ambassador_notifications.php.
 *
 * One trailing slash is tolerated so `.../manager/` and `.../manager` match.
 */
export const managerBaseUrl = String(
    import.meta.env.VITE_MANAGER_BASE_URL || 'https://apsession.com/manager'
).replace(/\/+$/, '');

export const appEnv = import.meta.env.VITE_APP_ENV || (import.meta.env.PROD ? 'production' : 'development');
export const isProductionAppEnv = appEnv === 'production';
